export const CHANGE_THEME = 'app_change_theme';
export const LOADING_THEME = 'app_loading_theme';



// WEBPACK FOOTER //
// ./src/redux/actions/types/appTypes.js